import { isOnboardingActivity, type OnboardingActivity } from '$types/clients.type';
import type { ParamMatcher } from '@sveltejs/kit';

export const match = ((param: string): param is OnboardingActivity => {
  return isOnboardingActivity(param);
}) satisfies ParamMatcher;
